import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import 'react-image-lightbox/style.css';
import registerServiceWorker from './registerServiceWorker';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Home, MobileHome } from './components/home';
import { Project, MobileProject } from './components/project';
import { ProjectView, MobileProjectView } from './components/viewProjects';
import { Contact, MobileContact } from './components/contact';
import { Firm, MobileFirm } from './components/firm';
import { Nav, MobileNav } from './components/nav';
import { Samples, MobileSamples } from './components/samples';
import './style/index.css';

// import data from './setup.json';
import { isUndefined } from 'util';

class App extends Component {
    state = {}

    componentDidMount() {
        // fetch('/setup.json', {cache: "no-store"}).then((response) => 
		// 	response.json().then((data) => this.setState({data}))
		// )

		const Http = new XMLHttpRequest();
        const url='https://ff5uysl1df.execute-api.us-west-2.amazonaws.com/ECobb';
        Http.open("GET", url);
        Http.send();

        Http.onreadystatechange = (e) => {
            // console.log(Http.response)
            try {
                const data = JSON.parse(Http.response)
                this.setState({ data })
            }
            catch (e){
            }
        }
    }

	render() {
		return (
			isUndefined(this.state.data) ? <br/> : <main>
				<BrowserView device={isBrowser} style={{ minWidth: '1010px', paddingLeft: '30px' }}>
					<Nav />
					<Switch>
						<Route exact path="/" component={() => <Home data={this.state.data} />} />
						<Route
							path="/projects/:type/:sort?/:name?"
							component={({ match }) => <ProjectView match={match} data={this.state.data} />}
						/>
						<Route
							path="/project/:name/:image?"
							component={({ match }) => <Project match={match} data={this.state.data} />}
						/>
						<Route path="/contact" component={() => <Contact data={this.state.data} />} />
						<Route path="/firm" component={() => <Firm data={this.state.data} />} />
						<Route path="/search" component={() => <Samples data={this.state.data} />} />
						<Redirect from="/*" to="/" />
					</Switch>
				</BrowserView>
				<MobileView device={isMobile}>
					<MobileNav />
					<Switch>
						<Route exact path="/" component={() => <MobileHome data={this.state.data} />} />
						<Route
							path="/projects/:type/:sort?"
							component={({ match }) => <MobileProjectView match={match} data={this.state.data} />}
						/>
						<Route
							path="/project/:name"
							component={({ match }) => <MobileProject match={match} data={this.state.data} />}
						/>
						<Route path="/contact" component={() => <MobileContact data={this.state.data} />} />
						<Route path="/firm" component={() => <MobileFirm data={this.state.data} />} />
						<Route path="/search" component={() => <MobileSamples data={this.state.data} />} />
						<Redirect from="/*" to="/" />
					</Switch>
				</MobileView>
			</main>
		);
	}
}

ReactDOM.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
	document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js